import React from "react";

// Recharts tooltip in the CRM dashboard style: title row plus one row per series.
const ChartTooltip = ({ active, payload, label, currency = "" }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="erp-tip">
      <div className="erp-tip-title">{label ?? payload[0]?.payload?.name}</div>
      {payload.map((p) => (
        <div className="erp-tip-row" key={p.dataKey ?? p.name}>
          <i style={{ background: p.color || p.payload?.fill }} />
          <span>{p.name}</span>
          <b>
            {Number(p.value || 0).toFixed(2)} {currency}
          </b>
        </div>
      ))}
    </div>
  );
};

export default ChartTooltip;
